<template>
  <qx-card title="列表">
    <LogRightDialog ref="logRightDialog" busiCode="22000023" />
    <section slot="titleRight">
      <qx-permpisions permpisions="1003020201">
        <el-button type="primary" plain @click="() => toEdit({})">
          <i class="iconfont">&#xe6ab;</i>报销
        </el-button>
      </qx-permpisions>
      <qx-permpisions permpisions="1003020205">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="payManagerBO.ajax?cmd=doQueryAllPayManager"
          :params="fullSearchData"
          bizName="管理费用数据导出"
          bizCode="exp100031"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section v-if="scope.column.property === 'applyUserName'">
                  <el-popover
                    trigger="hover"
                    :content="`司机手机：${scope.row.mobilePhone || ''}`"
                  >
                    <div slot="reference" class="primary cur">
                      {{ scope.row[scope.column.property] }}
                    </div>
                  </el-popover>
                </section>
                <section v-if="scope.column.property === 'receUserName'">
                  <el-popover
                    trigger="hover"
                    :content="`收款人手机：${scope.row.receMobilePhone || ''}`"
                  >
                    <div slot="reference" class="primary cur">
                      {{ scope.row[scope.column.property] }}
                    </div>
                  </el-popover>
                </section>
                <section v-if="scope.column.property === 'busiCode'">
                  <span class="primary cur" @click="toDetail(scope.row)">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <!-- 申请金额 -->
                <section v-if="scope.column.property === 'payAmt'">
                  <span
                    v-if="
                      scope.row.payAmt > 0 &&
                      scope.row.payType !== 4302 &&
                      scope.row.payType !== 4303 &&
                      scope.row.payType !== 4300
                    "
                    >{{ scope.row.payAmt }}</span
                  >
                  <span
                    v-else-if="!scope.row.payAmt || scope.row.payAmt === '0'"
                    >--</span
                  >
                  <el-popover
                    v-else-if="scope.row.payType === 4300"
                    title="申请金额"
                    trigger="hover"
                    :content="
                      scope.row.etcTrafficFee +
                      ' （ETC通行费）+ ' +
                      scope.row.etcServiceFee +
                      '（服务费）+' +
                      scope.row.etcLateFee +
                      '（滞纳金）'
                    "
                  >
                    <div slot="reference" class="primary cur">
                      {{ scope.row[scope.column.property] }}
                    </div>
                  </el-popover>
                  <el-popover
                    v-else
                    title="申请金额"
                    trigger="hover"
                    :content="
                      scope.row.principal +
                      ' （本金）+ ' +
                      scope.row.interest +
                      '（利息）'
                    "
                  >
                    <div slot="reference" class="primary cur">
                      {{ scope.row[scope.column.property] }}
                    </div>
                  </el-popover>
                  <span v-if="scope.row[scope.column.property] === '0'">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <!-- 申请金额 end -->
                <!-- 抵扣借支 -->
                <section v-if="scope.column.property === 'deductAmount'">
                  <DeductDetail
                    v-if="scope.row[scope.column.property] !== '0'"
                    :itemData="scope.row"
                  />
                  <span v-if="scope.row[scope.column.property] === '0'">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <!-- 抵扣借支 end -->
                <section
                  v-if="
                    scope.column.property !== 'busiCode' &&
                    scope.column.property !== 'payAmt' &&
                    scope.column.property !== 'deductAmount' &&
                    scope.column.property !== 'applyUserName' &&
                    scope.column.property !== 'receUserName'
                  "
                >
                  {{ scope.row[scope.column.property] }}
                </section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="140"
            fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    permpisions: '1003020204',
                    showCondition: (scope.row.state == 0 || scope.row.state == 4) && scope.row.isAudit == 1,
                    name: '审核',
                    event: () => toDetail(scope.row, 'approve'),
                  },
                  {
                    permpisions: '1003020202',
                    showCondition:
                      scope.row.state === 0 || scope.row.state === 1,
                    name: '修改',
                    event: () => toEdit(scope.row),
                  },
                  {
                    permpisions: '1003020203',
                    showCondition:
                      scope.row.state === 0 || scope.row.state === 1,
                    name: '取消',
                    event: () => cancel(scope.row),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.payId),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import ExportBtn from 'components/exportBtn';
import DeductDetail from './deductDetail';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  manageList,
  manageCancel,
} from 'api/cost';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    ExportBtn,
    DeductDetail,
    TableBtn,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'busiCode', label: '申请单号', fixed: true },
          { prop: 'applyTime', label: '申请时间' },
          { prop: 'applyUserName', label: '申请人', slot: true },
          { prop: 'payTypeName', label: '费用类型' },
          { prop: 'payAmt', label: '申请金额' },
          { prop: 'orgName', label: '费用归属' },
          { prop: 'receUserName', label: '收款人' },
          { prop: 'remark', label: '费用说明' },
          { prop: 'stateName', label: '状态' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: manageList,
    toDetail (item, type = '') {
      this.jump({
        label: type ? '审核管理费用' : '管理费用详情',
        url: `/manage/cost/manage/detail?id=${item.payId}&type=${type}`,
        full: true,
      });
    },
    toLine (item) {
      this.jump({
        label: '线路档案',
        url: '/manage/archives/customer/line?companyName=' + item.companyName,
      });
    },
    toEdit (item) {
      this.jump({
        label: (item.payId ? '修改报销' : '新增申请报销'),
        url: `/manage/cost/manage/feeEdit?id=${item.payId || ''}&subjectsType=2&receiverMan=${item.applyUserName ? encodeURIComponent(item.applyUserName) : ''}`,
        full: true,
      });
    },
    // 查看报销明细
    toReimbursementDetails () {
      // 前往 车辆费用 - 车辆费用报销 - 车辆费用报销明细
    },
    showLog (customerId) {
      this.$refs.logRightDialog.show(customerId);
    },
    async cancel (item) {
      const confirmRes = await this.$confirm('是否确定取消该借支？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
        this.$message({
          type: 'info',
          message: '已取消操作',
        });
      });
      if (confirmRes === 'confirm') {
        const delRes = await manageCancel({
          payId: item.payId,
          state: 5,
        });
        if (!delRes.failed) {
          this.$message({
            type: 'success',
            message: '取消成功',
          });
          this.getData();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
